import React from 'react';
import LazyloadImage from '../sharedComponents/LazyloadImage';
import classNames from 'classnames';
import CtaButton from '../sharedComponents/CtaButton';

import './payout.scss';

const descriptionClasses = classNames(
    'description-parent',
    'eds-text-color--grey-700',
    'eds-text-bl',
    'eds-text-weight--regular',
    'eds-l-mar-top-4',
    'eds-text--center',
    'eds-l-pad-bot-10',
);

interface PayoutBoxComponentProps {
    headline: string;
    description: string;
    icon: string;
}

interface PayoutProps {
    header: string;
    description: string;
    payoutBoxes: PayoutBoxComponentProps[];
    button: any;
}

const PayoutBoxComponent = ({
    headline,
    description,
    icon,
}: PayoutBoxComponentProps) => (
    <div className="eds-g-cell eds-g-cell-sm-1-1 eds-g-cell-sw-1-3 eds-l-pad-all-4 eds-l-sm-pad-all-2">
        <div style={{ height: '100%' }} className="eds-l-pad-bot-8 ">
            <LazyloadImage
                image={icon}
                classes="mktg-icon-lg eds-align--center mktg-icon-overlap"
                style={{}}
            />
            <div className="payout-text mktg-shadow-secondary eds-bg-color--white eds-l-pad-top-10">
                <div className="eds-l-pad-hor-8 eds-l-pad-top-8">
                    <p className="eds-text-bl eds-text-weight--heavy eds-text-color--grey-900 eds-l-pad-bot-2 eds-text--center">
                        {headline}
                    </p>
                    <div
                        className="description-parent eds-text-bm eds-text-color--grey-700 eds-text--center"
                        dangerouslySetInnerHTML={{
                            __html: description,
                        }}
                    />
                </div>
            </div>
        </div>
    </div>
);

const PayoutModule = ({
    header,
    description,
    payoutBoxes,
    button,
}: PayoutProps) => (
    <section className="payout-module">
        <div className="marketing-container__max-width ">
            <div className="eds-g-grid mktg-top-p-100">
                <div className="grey_900_half_bg">
                    <div className="eds-g-cell eds-g-cell-12-12 eds-g-offset-0-12 eds-g-cell-md-8-12 eds-g-offset-md-2-12 eds-l-pad-hor-6 ">
                        <h2 className="eds-text-color--grey-900 eds-text-hm eds-text--center mktg-text-weight--heavy eds-text--center ">
                            {header}
                        </h2>
                        <div
                            className={descriptionClasses}
                            dangerouslySetInnerHTML={{
                                __html: description,
                            }}
                        />
                    </div>
                    <div className="eds-l-lg-pad-hor-2">
                        <div className=" eds-g-cell-12-12 eds-g-offset-0-12 ">
                            <div className="equal-height-cards">
                                {payoutBoxes.map((box, index) => (
                                    <PayoutBoxComponent {...box} key={index} />
                                ))}
                            </div>
                            <div className="eds-text--center eds-l-mar-bot-6 eds-l-mar-top-4">
                                <CtaButton
                                    buttonUrl={button.url}
                                    buttonText={button.callToAction}
                                    buttonClasses={
                                        'eds-btn eds-btn--button eds-btn--fill eds-btn--responsive'
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);
export default PayoutModule;
